<ng-container *ngIf="(user$ | async).loaded; else loader">
  <ecp-hero title="Find the Perfect Frame to order" image="assets/images/headers/experts.jpg"> </ecp-hero>

  <div class="container">
    <div class="row is-flex">
      <div class="col is-flex is-fullwidth">
        <ecp-catalog-search></ecp-catalog-search>
      </div>

      <div class="col is-flex is-fullwidth">
        <ecp-browse-catalog></ecp-browse-catalog>
      </div>
    </div>
  </div>
  <!--   <ecp-add-to-cart-notifications [notifications]="notifications$ | async"></ecp-add-to-cart-notifications> -->
</ng-container>

<ng-template #loader>
  <ecp-loader></ecp-loader>
</ng-template>
